
  /**
   * PAGE_LOAD_EVENT
   */
    export default class PAGE_LOAD_EVENT{
      /**
       * @param  {Function} callback
       * @param  {String}   type     'all', 'load', 'change'
       */
      load(callback,type = 'all'){
        if(typeof callback == 'function'){
          this.flag =!1;
          this.callback = callback;
          this.set(type=='load'?type:type=='change'?type:'all');
        }
      }
      set(type){
        switch(type){
          case 'load':
            window.addEventListener("pageshow",e=>{this.func(e)},!1);
            window.addEventListener("load",e=>{this.func(e)},!1);
            break;
          case 'change':
            window.addEventListener("hashchange",e=>{this.func(e)},!1);
            document.addEventListener("readystatechange",e=>{this.func(e)},!1);
            break;
          case 'all':
            window.addEventListener("pageshow",e=>{this.func(e)},!1);
            window.addEventListener("load",e=>{this.func(e)},!1);
            window.addEventListener("hashchange",e=>{this.func(e)},!1);
            document.addEventListener("readystatechange",e=>{this.func(e)},!1);
            break;
        }
        document.addEventListener("DOMContentLoaded",e=>{this.func(e)},!1);
      }
      func(e){
        if(this.flag == !1){
          this.flag =!0;
          this.callback(e);
        }
      }
    }
